/* eslint-disable import/extensions */
/* eslint-disable import/first */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/order */
/* eslint-disable max-len */
/* eslint-disable func-names */
/* eslint-disable no-undef */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable no-duplicate-case */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useContext,
    useState,
    useEffect,
    useCallback,
    Suspense
} from 'react';
import { Switch, Route } from 'react-router-dom';
import _ from 'lodash';
// Imported First to allow Jutro styles to be overridden
import './App.scss';
import { setComponentMapOverrides } from '@jutro/uiconfig';
import {
    Main,
    Icon,
    Chevron,
    ModalNextProvider
} from '@jutro/components';
import { Table, TableColumn } from '@jutro/datatable';
import { TranslatorContext, LocaleService } from '@jutro/locale';
import { NavRoutes } from '@jutro/router';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import {
    DynamicRoute, GrantedAuthorities, withAuthContextProvider, useAuthentication
} from 'gw-digital-auth-react';
import vmTranslator, { messages as commonMessages } from 'gw-platform-translations';
import { AccurateBreakpointPropagation } from 'gw-jutro-adapters-react';
import { ViewModelServiceFactory } from 'gw-portals-viewmodel-js';
import { LoginCapabilityComponentMap, LoginCapabilityComponents } from 'gw-portals-login-react';
import { UsersProfile } from 'gw-capability-profileinfo-react';

import { DependencyProvider } from 'gw-portals-dependency-react';

import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import {
    platformComponentMap,
    platformComponents,
    ImageComponent,
} from 'gw-components-platform-react';
import { ErrorBoundary } from 'gw-portals-error-react';

// import { filterCapabilityRoutes } from 'gw-portals-config-js';

// ospcchange add entrypage component for localhost testing, pending investigation for dev/sit deployment
// import custom component EntryPage
import EntryPage from '../pages/EntryPage/EntryPage';

import { routes } from './App.routes.metadata.json5';
// const custom component LandingPage
const LandingPage = React.lazy(() => import('../pages/LandingPage/LandingPage'));
// const custom message file for App component.
import messages from './App.messages';
// imposrt custom component SessionTimeoutModal
const SessionTimeoutModal = React.lazy(() => import('../wsib/common/session-timeout-modal/session-timeout-modal'));
// imposrt custom component SessionTimeoutService
import SessionTimeoutService from '../wsib/services/SessionTimeoutService';
// const custom component ClaimSummaryHome
const ClaimSummaryHome = React.lazy(() => import('../wsib/claim-dashboard/pages/claim-summary-home/claim-summary-home'));
const ClaimEnrollmentHome = React.lazy(() => import('../wsib/claim-dashboard/pages/claim-enrollment-home/claim-enrollment-home.jsx'));

const NotificationsHome = React.lazy(() => import('../wsib/claim-dashboard/pages/notifications-home/notifications-home.jsx'));
// const {custom component SessionExpiredHome
import SessionExpiredHome from '../wsib/common/pages/session-expired-home';

const Document = React.lazy(() => import('../wsib/claim-details/document/page/document'));
const DocumentHistory = React.lazy(() => import('../wsib/claim-details/document/page/documentHistoryPage'));
const DirectDeposit = React.lazy(() => import('../wsib/claim-dashboard/pages/direct-deposit-home/direct-deposit-home'));
const ProfileAuth = React.lazy(() => import('../wsib/auth-dashboard/profile-authenticator/profile-authenticator'));
const SignupConfirmation = React.lazy(() => import('../wsib/auth-dashboard/signup-confirmation/signup-confirmation'));
const ReportOverview = React.lazy(() => import('../wsib/claim-dashboard/report-overview/report-overview'));
// const {custom component Header
const Header = React.lazy(() => import('../wsib/common/header/header'));
// const {custom= React.lazy(() => import(onent Footer
const Footer = React.lazy(() => import('../wsib/common/footer/footer'));
// const {custom component LeftNav
const LeftNav = React.lazy(() => import('../wsib/common/left-nav/left-nav'));
// const {custom component ClaimOverviewHome
const ClaimOverviewHome = React.lazy(() => import('../wsib/claim-details/claim-overview/page/claim-overview-home'));
// const {custom component BenefitPaymentHome
const BenefitPaymentHome = React.lazy(() => import('../wsib/claim-details/benefit-payment/page/benefit-payment-home'));

const EnrollmentConfirmation = React.lazy(() => import('../wsib/claim-dashboard/pages/enrollment-confirmation-home/enrollment-confirmation-home'));
// const {custom loader coponent MakePaymentPage
import { LoaderComponentComponentMap, LoaderComponentComponents } from '../wsib/common/loader/page/index';
// const {custom component ClaimTombstone
const ClaimTombstone = React.lazy(() => import('../wsib/common/claim-tombstone/claim-tombstone'));
// const {custom component Logout
const Logout = React.lazy(() => import('../wsib/common/logout/logout'));
// const {UtilService
import UtilService from '../wsib/services/UtilService';
const EditContactInfo = React.lazy(() => import('../wsib/claim-dashboard/pwi-contact-info/pwi-edit-contact-info/pwi-edit-contact-info.jsx'));
// const {custom component EditMailingAddress
const EditMailingAddress = React.lazy(() => import('../wsib/claim-dashboard/pwi-contact-info/edit-mailing-address/edit-mailing-address.jsx'));
// const {custom component EditPhoneNumber
const EditPhoneNumber = React.lazy(() => import('../wsib/claim-dashboard/pwi-contact-info/edit-phone-number/edit-phone-number.jsx'));
// const {custom component MyProfile
const MyProfile = React.lazy(() => import('../wsib/claim-dashboard/pwi-contact-info/pwi-contact-info/pwi-contact-info.jsx'));
// const {custom component faqLink
const FaqLink = React.lazy(() => import('../wsib/common/faq-link/faq-link'));
// const {custom component HelpfulLinks
const HelpfulLink = React.lazy(() => import('../wsib/common/helpful-links/helpful-links'));
// const {custom component HealthCareHome
const HealthCareHome = React.lazy(() => import('../wsib/claim-details/healthcare-benefits/page/healthcare-home'));
// const {custom component appeals
const AppealsHome = React.lazy(() => import('../wsib/claim-details/appeals/page/appeals-home'));
// import custom component NonHealthCareHome
const NonHealthCareHome = React.lazy(() => import('../wsib/claim-details/non-healthcare-benefits/page/non-healthcare-benefits-home'));
// const {custom component Login
import Login from '../wsib/login/login';
// const {custom component ClaimIntake
const ClaimIntake = React.lazy(() => import('../wsib/claim-intake/pages/claim-intake'));
// const {custom component MailHome
const MailHome = React.lazy(() => import('../wsib/claim-details/mail/page/mail-home'));
// const {custom component Send Message
const SendMessage = React.lazy(() => import('../wsib/claim-details/messaging/send-message/send-message'));
// const {custom context AppContext
import AppContext from '../wsib/app-context/app-context';
// const {custom component MailDetail
const MailDetail = React.lazy(() => import('../wsib/claim-details/mail/mail-detail/mail-detail'));
const SuccessMessage = React.lazy(() => import('../wsib/claim-details/mail/mail-success/mail-success'));
// const {IdpCallbackComponent to handle b2c error
const IdpCallbackComponent = React.lazy(() => import('../wsib/common/IdpCallbackComponent/IdpCallbackComponent'));
const unlockDirectDeposit = React.lazy(() => import('../wsib/claim-dashboard/direct-deposit/unlock-direct-deposit/unlock-direct-deposit'));
const noPinDirectdeposit = React.lazy(() => import('../wsib/claim-dashboard/direct-deposit/no-pin-direct-deposit/no-pin-direct-deposit'));
const IdpSystemErrorHome = React.lazy(() => import('../wsib/common/pages/idp-system-error-home'));

const SystemErrorHome = React.lazy(() => import('../wsib/common/pages/system-error-home'));
const UnsupportedBrowserHome = React.lazy(() => import('../wsib/common/pages/unsupported-browser-home'));

const LockOutMessage = React.lazy(() => import('../wsib/claim-dashboard/pages/claim-lockout-message/lock-out-message'));
import NotificationContext from '../wsib/claim-dashboard/notifications/notification-context/notification-context.jsx';
import UnsupportedBrowserBanner from '../wsib/common/UnsupportedBrowserBanner/UnsupportedBrowserBanner.jsx';

const TopButton = React.lazy(() => import('../wsib/common/topButton/TopButton.jsx'));
const OnlineServices = React.lazy(() => import('../wsib/auth-dashboard/online-services-page/online-services-page'));
const RedirectToPortal = React.lazy(() => import('../wsib/auth-dashboard/pages/redirect-to-portal'));
import ClaimRelatedDocumentsPage from '../wsib/claim-details/claim-related-documents/ClaimRelatedDocumentsPage.jsx';
import { reactPlugin, trackEvent, withAITracking } from '../wsib/common/application-insight/application-insight.jsx';

import InfoBanner from '../wsib/common/info-banner/infoBanner.jsx';

const componentMap = {
    document: Document,
    documentHistory: DocumentHistory,
    claimRelatedDocuments: ClaimRelatedDocumentsPage,
    DirectDeposit: DirectDeposit,
    unlockDirectDeposit: unlockDirectDeposit,
    noPinDirectdeposit: noPinDirectdeposit,
    reportOverview: ReportOverview,
    sessionTimeout: SessionTimeoutModal,
    claimSummaryHome: ClaimSummaryHome,
    claimOverviewHome: ClaimOverviewHome,
    addClaimWizard: ClaimEnrollmentHome,
    notificationsHome: NotificationsHome,
    claimEnrollmentHome: ClaimEnrollmentHome,
    editContactInfo: EditContactInfo,
    editMailingAddress: EditMailingAddress,
    editPhoneNumber: EditPhoneNumber,
    myProfile: MyProfile,
    benefitPaymentHome: BenefitPaymentHome,
    helpfulLink: HelpfulLink,
    faqLink: FaqLink,
    healthCareHome: HealthCareHome,
    nonHealthCareHome: NonHealthCareHome,
    appealsHome: AppealsHome,
    mailHome: MailHome,
    landingpage: LandingPage,
    usersprofile: UsersProfile,
    sendMessage: SendMessage,
    successMessage: SuccessMessage,
    enrollmentConfirmation: EnrollmentConfirmation,
    mailDetail: MailDetail,
    claimIntake: ClaimIntake,
    lockOutMessage: LockOutMessage,
    ProfileAuth: ProfileAuth,
    OnlineServices: OnlineServices,
    RedirectToPortal: RedirectToPortal,
    SignupConfirmation: SignupConfirmation,
};

// eslint-disable-next-line no-unused-vars
const shouldRouteToSignUp = (authorities) => {
    // ospcchange: todo investigate the below osbc code and see whether it is applicable to ospc logic
    // const accountAuthorities = authorities.filter((authority) => authority.authorityType === 'ACCOUNT');
    // if (accountAuthorities.length === 0) {
    //     window.location.href = UtilService.businessLink(LocaleService.getCurrentLanguage());
    // }
    UtilService.previousRole = UtilService.getUserRole();
    UtilService.previousRoleArr = document.getElementsByTagName('html')[0].getAttribute('accesToken');
    return null;
};

setComponentMapOverrides(
    {
        ...platformComponentMap,
        ...LoginCapabilityComponentMap,
        ...LoaderComponentComponentMap,
        Icon: { component: 'Icon' },
        Table: { component: 'Table' },
        TableColumn: { component: 'TableColumn' },
        Chevron: { component: 'Chevron' },
        img: { component: 'img' },
        infoBanner: { component: 'infoBanner' },
    },
    {
        ...platformComponents,
        ...LoginCapabilityComponents,
        ...LoaderComponentComponents,
        Icon,
        Table,
        TableColumn,
        Chevron,
        img: ImageComponent,
        infoBanner: InfoBanner,
    }
);

// (Router) Title is required and used for (Browser) title
// in a format of "${title} - ${appName}". In order to show
// the application name only, it needs to be an empty value.
// const routesWithTitle = filterCapabilityRoutes(capabilitiesConfig, routes);
const routesWithoutTitle = routes.map((route) => {
    return {
        ...route,
        title: ''
    };
});
let inactivityTimer = null;
let isExpired = false;

function App() {
    const appVersion = '1.1.234';

    const auth = useAuthentication();
    const translator = useContext(TranslatorContext);
    const [viewModelService, setViewModelService] = useState(undefined);
    const [showLeftNav, setshowLeftNav] = useState(true);
    const [aodaPageTitle, setAodaPageTitle] = useState(translator(messages.claimsPageTitle));
    const [notificationData, setNotificationData] = useState({});
    const language = LocaleService.getStoredLanguage();

    const setDecodedEncodedKeywords = useCallback((value) => {
        localStorage.setItem('setDecodedEncodedKeywords', value);
    }, []);

    const setSpecialCharReplaceWithUniCodeKeywords = useCallback((value) => {
        localStorage.setItem('setSpecialCharReplaceWithUniCodeKeywords', value);
    }, []);

    const getDecodedEncodedKeywords = useCallback(() => {
        return localStorage.getItem('setDecodedEncodedKeywords');
    }, []);

    const getSpecialCharReplaceWithUniCodeKeywords = useCallback(() => {
        return localStorage.getItem('setSpecialCharReplaceWithUniCodeKeywords');
    }, []);

    const userSettings = {
        setDecodedEncodedKeywords,
        setSpecialCharReplaceWithUniCodeKeywords,
        getDecodedEncodedKeywords,
        getSpecialCharReplaceWithUniCodeKeywords
    };


    useEffect(() => {
        const translatorFn = vmTranslator(translator);
        import(
            /* webpackChunkName: "product-metadata" */
            // eslint-disable-next-line import/no-unresolved
            'product-metadata'
        ).then((productMetadata) => {
            const { default: result } = productMetadata;
            setViewModelService(
                ViewModelServiceFactory.getViewModelService(result, translatorFn)
            );
        });
    }, []);

    useEffect(() => {
        console.log(`OSPC App version: ${appVersion}`);
        trackEvent(`OSPC start ${appVersion}`, {
            Version: appVersion,
            url: window.location.href,
            component: App.name,
            browser: navigator.userAgent
        });
        const currentLang = LocaleService.getStoredLocale();
        const { search } = window.location;
        const params = new URLSearchParams(search);
        const lang = params.get('lang');
        const action = params.get('action');
        if (localStorage.getItem('addClaim') !== null && localStorage.getItem('addClaim').includes('/account-management/newAddclaim/enrollment') && window.location.pathname === '/') {
            console.log(' i am here');
            window.location.href = '/account-management/newAddclaim/enrollment';
            localStorage.removeItem('addClaim');
        }
        if (lang && window.location.pathname.includes('/account-management/newAddclaim/enrollment')) {
            console.log('window.location.pathname', window.location.pathname);
            localStorage.setItem('addClaim', window.location.pathname);
        }
        if (lang) {
            if (lang === 'fr' && lang !== currentLang) {
                LocaleService.setCurrentLocale(lang);
                LocaleService.setCurrentLanguage(lang);
                window.location.reload();
            }
            if (lang === 'en' && lang !== currentLang) {
                LocaleService.setCurrentLocale(lang);
                LocaleService.setCurrentLanguage(lang);
                window.location.reload();
            }
        } else if (currentLang) {
            const currentLangStr = currentLang.substring(0, 2);
            if (currentLangStr === 'en' || currentLangStr === 'fr') {
                LocaleService.setCurrentLocale(currentLangStr);
                LocaleService.setCurrentLanguage(currentLangStr);
            }
        } else {
            LocaleService.setCurrentLocale('en');
            LocaleService.setCurrentLanguage('en');
        }

        if (action === 'CreateProfile') {
            sessionStorage.setItem('isCreateProfile', 'true');
        }
    }, [LocaleService]);

    const showLeftNavfn = () => {
        console.log(window.location.pathname);
        if ((['/account-management/claims', '/account-management/newAddclaim', '/account-management/newAddclaim/enrollment', '/account-management/newAddclaim/securityquestion', '/account-management/newAddclaim/enterclaimpin',
            '/account-management/newAddclaim/claimsuccess', '/account-management/notifications', '/account-management/session-expired', '/account-management/lockout-message'].indexOf(window.location.pathname) !== -1)
            || (window.location.pathname.indexOf('/account-management/enrollmentconfirmation') !== -1)
            || (window.location.pathname.indexOf('/account-management/directdeposit') !== -1)
            || (window.location.pathname.indexOf('/account-management/claim-intake') !== -1)
            || (window.location.pathname.indexOf('/account-management/reportOverview') !== -1)
            || (window.location.pathname.indexOf('/account-management/noPinDirectdeposit') !== -1)
            || (window.location.pathname.indexOf('/account-management/unlockDirectDeposit') !== -1)
            || (window.location.pathname.indexOf('/account-management/newAddclaim/enterclaimpin') !== -1)
            || (window.location.pathname.indexOf('/account-management/signup-confirmation-f6q') !== -1)
            || (window.location.pathname.indexOf('/account-management/profile-authenticator') !== -1)
            || (window.location.pathname.indexOf('/account-management/signup-confirmation') !== -1)
            || (window.location.pathname.indexOf('/account-management/MyContactInformation') !== -1)
            || (window.location.pathname.indexOf('/account-management/myProfile') !== -1)) {
            setshowLeftNav(true);
        } else {
            setshowLeftNav(false);
        }
    };

    /* hide left nav component if current screen is not home screen */
    useEffect(() => {
        let defaultScreen = 0;
        const elementRef = document.getElementById('pageTitle');
        if ('/account-management/session-expired'.indexOf(window.location.pathname) !== -1) {
            isExpired = true;
            inactivityTimer = null;
        } else {
            isExpired = false;
        }
        if (window.location.pathname.includes('/account-management/claims')) {
            defaultScreen = 0;
            document.title = translator(messages.claimsPageTitle);
            setAodaPageTitle(translator(messages.claimsPageTitle));
        } else if (window.location.pathname.includes('/account-management/notifications')) {
            defaultScreen = 0;
            document.title = translator(messages.notifications);
            setAodaPageTitle(translator(messages.notifications));
        } else if (window.location.pathname.includes('/account-management/addclaim')) {
            defaultScreen = 0;
            document.title = translator(messages.addClaimPageTitle);
            setAodaPageTitle(translator(messages.addClaimPageTitle));
        } else if (window.location.pathname.includes('/account-management/newAddclaim')) {
            defaultScreen = 0;
            document.title = translator(messages.addClaimPageTitle);
            setAodaPageTitle(translator(messages.addClaimPageTitle));
        } else if (window.location.pathname.includes('/account-management/enrollmentconfirmation')) {
            defaultScreen = 0;
            document.title = translator(messages.claimConfirmationPageTitle);
            setAodaPageTitle(translator(messages.claimConfirmationPageTitle));
        } else if (window.location.pathname.includes('/account-management/claimOverview')) {
            defaultScreen = 0;
            document.title = translator(messages.claimOverviewPageTitle);
            setAodaPageTitle(translator(messages.claimOverviewPageTitle));
        } else if (window.location.pathname.includes('/account-management/benefitPayment')) {
            defaultScreen = 0;
            document.title = translator(messages.benefitPaymentPageTitle);
            setAodaPageTitle(translator(messages.benefitPaymentPageTitle));
        } else if (window.location.pathname.includes('/account-management/healthCare')) {
            defaultScreen = 0;
            document.title = translator(messages.healthCarePageTitle);
            setAodaPageTitle(translator(messages.healthCarePageTitle));
        } else if (window.location.pathname.includes('/account-management/nonHealthCare')) {
            defaultScreen = 0;
            document.title = translator(messages.nonHealthCarePageTitle);
            setAodaPageTitle(translator(messages.nonHealthCarePageTitle));
        } else if (window.location.pathname.includes('/account-management/appeals')) {
            defaultScreen = 0;
            document.title = translator(messages.appealsPageTitle);
            setAodaPageTitle(translator(messages.appealsPageTitle));
        } else if (window.location.pathname.includes('/account-management/documentUpload')) {
            defaultScreen = 0;
            document.title = translator(messages.claimDocumentsPageTitle);
            setAodaPageTitle(translator(messages.claimDocumentsPageTitle));
        } else if (window.location.pathname.includes('/account-management/documentHistory')) {
            defaultScreen = 0;
            document.title = translator(messages.documentHistoryPageTitle);
            setAodaPageTitle(translator(messages.documentHistoryPageTitle));
        } else if (window.location.pathname.includes('/account-management/claimRelatedDocuments')) {
            defaultScreen = 0;
            document.title = translator(messages.claimRelatedDocumentsPageTitle);
            setAodaPageTitle(translator(messages.claimRelatedDocumentsPageTitle));
        } else if (window.location.pathname.includes('/account-management/directdeposit')) {
            defaultScreen = 0;
            document.title = translator(messages.claimDirectdepositPageTitle);
            setAodaPageTitle(translator(messages.claimDirectdepositPageTitle));
        } else if (window.location.pathname.includes('/account-management/sendmessage')) {
            defaultScreen = 0;
            document.title = translator(messages.sendUsMessagePageTitle);
            setAodaPageTitle(translator(messages.sendUsMessagePageTitle));
        } else if (window.location.pathname.includes('/account-management/mail')) {
            defaultScreen = 0;
            setAodaPageTitle(translator(messages.mailPageTitle));
            document.title = translator(messages.mailPageTitle);
        } else if (window.location.pathname.includes('/account-management/faq-link')) {
            defaultScreen = 0;
            document.title = translator(messages.faqLinkPageTitle);
            setAodaPageTitle(translator(messages.faqLinkPageTitle));
        } else if (window.location.pathname.includes('/account-management/helpful-link')) {
            defaultScreen = 0;
            document.title = translator(messages.helpFullLinkPageTitle);
            setAodaPageTitle(translator(messages.helpFullLinkPageTitle));
        } else if (window.location.pathname.includes('/account-management/MyContactInformation')) {
            defaultScreen = 0;
            document.title = translator(messages.myContactInformationPageTitle);
            setAodaPageTitle(translator(messages.myContactInformationPageTitle));
        } else if (window.location.pathname.includes('/account-management/contactInfo')) {
            defaultScreen = 0;
        }
         else {
            defaultScreen = 1;
            document.title = translator(messages.defaultPageTitle);
            setAodaPageTitle(translator(messages.defaultPageTitle));
        }

        const claimNumber = UtilService.fetchClaimNumber();
        trackEvent(`Navigate to page - ${document.title} -  ${claimNumber}`, {
            claimNumber: claimNumber,
            location: window.location.pathname,
            component: App.name,
            documentTitel: document.title
        });

        if (elementRef) {
            elementRef.focus();
        }
        if (defaultScreen === 0) {
            window.scrollTo(0, 0);
        }
        showLeftNavfn();
    }, [window.location.pathname]);

    const resetSessionTimer = () => {
        if (inactivityTimer !== null) {
            inactivityTimer.resetInactivityTimer();
        }
    };
    useEffect(() => {
        document.addEventListener('click', resetSessionTimer);
        document.addEventListener('mousedown', resetSessionTimer);
        document.addEventListener('touchstart', resetSessionTimer);
        document.addEventListener('touchmove', resetSessionTimer);
        document.addEventListener('keydown', resetSessionTimer);

        // jutro upgrade check
        // SE-1280, SE-1283 (DI-11) remove jutro skipNav link element
        // check if new jutro version updates the blow css style class name
        const skipcomponent = document.querySelector('.jut__SkipNav__skipNav');
        if (skipcomponent) {
            skipcomponent.remove();
        }

        return () => {
            document.removeEventListener('click', resetSessionTimer);
            document.removeEventListener('mousedown', resetSessionTimer);
            document.removeEventListener('touchstart', resetSessionTimer);
            document.removeEventListener('touchmove', resetSessionTimer);
            document.removeEventListener('keydown', resetSessionTimer);
        };
    }, []);
    useEffect(() => {
        const interval = setInterval(() => {
            const header = document.querySelector('#header-main-container');
            if (header){
                if (document.getElementById("footerElement")) {
                    document.getElementById("footerElement")?.removeAttribute("hidden");
                }
                clearInterval(interval);
            }
        }, 500);
        var footerEle = document.getElementById("footerElement");
        const lang = LocaleService.getStoredLocale();
        footerEle?.setAttribute("lang", lang);
        return () =>  clearInterval(interval);
    },);

    const handleError = useCallback(() => {
        // ospcchange the below dialog does not show when unhandled error happens, need more investigation
        // it is better to log the exception to appliation insight and console log, and then redirect ui to system error page instead
        // of show an error dialog.
        return ModalNextProvider.showAlert({
            title: messages.error,
            message: messages.errorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    }, []);

    if (auth.isLoggedIn && !isExpired) {
        inactivityTimer = SessionTimeoutService();
        inactivityTimer.resetInactivityTimer();
    }

    // AODA Skip to main content function
    const skipLink = (e) => {
        e.preventDefault();
        const wsibNodes = document.querySelectorAll('.wsib_ospcMainContainer');
        const intakeNodes = document.querySelectorAll('.bodyContainer');
        const nodes = document.querySelectorAll('.osbcMainContainer');
        const noHashURL = window.location.href.replace(/#.*$/, '');
        window.history.replaceState('', document.title, noHashURL);
        if (!e.key || e.key === 'Enter') {
            if (wsibNodes.length > 0) {
                if (wsibNodes[0].id) {
                    document.location.hash = wsibNodes[0].id;
                }
            } else if (nodes.length > 0) {
                if (nodes[0].id) {
                    document.location.hash = nodes[0].id;
                }
            } else if (intakeNodes.length > 0) {
                if (intakeNodes[0].id) {
                    document.location.hash = intakeNodes[0].id;
                }
            }
        }
        return false;
    };

    useEffect(() => {
        const { search } = window.location;
        console.log("check search in app.js", search)
        const params = new URLSearchParams(search);
        console.log("check params in app.js", params)
        if(params.get('authAppSetup')) {
            console.log("Inside auth if condition", params.get('authAppSetup'))
            sessionStorage.setItem("authAppSetupValue", params.get('authAppSetup'));
        }
        // const currentLang = LocaleService.getStoredLocale();
        // const lang = params.get('lang');
        const secureRoutes = ['/account-management/signup-confirmation-f6q', '/account-management/signup-confirmation', '/account-management/claim-intake', '/account-management/notifications'];
        console.log('window.location.pathname in App useEffect', window?.location?.pathname, auth?.isLoggedIn);
        localStorage.setItem('pathName', window.location.pathname);
        if (!auth?.isLoggedIn && secureRoutes?.includes(window?.location?.pathname)) {
            sessionStorage.setItem('redirectUrl', window.location?.pathname);
            localStorage.setItem('signupSuccess', true);
            // if (lang && currentLang !== lang) {
            //     LocaleService.setCurrentLocale(lang);
            //     LocaleService.setCurrentLanguage(lang);
            // }
        }
    }, []);


    return (
        <>
            <p id="pageTitle" className="pageTittle" role="alert">{aodaPageTitle}</p>
            <Suspense fallback={null}>
                <AppContext.Provider value={userSettings}>
                    <React.Fragment> 
                        <AccurateBreakpointPropagation>
                            <DependencyProvider
                                value={{
                                    SessionTimeoutService: SessionTimeoutService
                                }}
                            >
                                <ErrorBoundary onError={handleError}>
                                    <ViewModelServiceContext.Provider value={viewModelService}>
                                        <ModalNextProvider />
                                                                        <NotificationContext.Provider value={{ notificationData, setNotificationData }}>
                                        <Switch>
                                            {(appConfig.env.DEPLOYMENT_HOSTNAME === 'localhost') && <Route exact path="/login-page" component={EntryPage} />}
                                            {(appConfig.env.DEPLOYMENT_HOSTNAME !== 'localhost') && <Route exact path="/login-page" component={Login} />}
                                            <Route exact path="/session-expired" component={SessionExpiredHome} />
                                            <Route path="/idp-system-error-home" component={IdpSystemErrorHome} />
                                            <Route path="/system-error" component={SystemErrorHome} />
                                            <Route path="/ospcLogout" component={Logout} />
                                            <Route path="/ospc/uaa/login/callback/microsoftb2c" component={IdpCallbackComponent} />
                                            <DynamicRoute path="/">
                                                <GrantedAuthorities
                                                    checkRenderBasedOnAuthorities={shouldRouteToSignUp}
                                                >
                                                    <UnsupportedBrowserBanner />
                                                    <Header />
                                                    {
                                                        (showLeftNav) ? (
                                                            <Main>
                                                                <NavRoutes
                                                                    resolveComponentMap={componentMap}
                                                                    routes={routesWithoutTitle}
                                                                />
                                                            </Main>

                                                        ) : (
                                                            <Main>
                                                                <aside tabIndex="-1" id="bodySection" className="osbcMainContainer"><ClaimTombstone /></aside>
                                                                <div id="wsib_ospcBodySection" className="wsib_ospcMainContainer leftNavMainClass">
                                                                    <LeftNav />
                                                                    <NavRoutes
                                                                        resolveComponentMap={componentMap}
                                                                        routes={routesWithoutTitle}
                                                                    />
                                                                </div>
                                                            </Main>
                                                        )
                                                    }
                                                    <div className="topButton text-right">
                                                        <TopButton language={language} />
                                                    </div>
                                                </GrantedAuthorities>
                                            </DynamicRoute>
                                        </Switch>
                                    </NotificationContext.Provider>
                                </ViewModelServiceContext.Provider>
                            </ErrorBoundary>
                        </DependencyProvider>
                    </AccurateBreakpointPropagation>
                </React.Fragment>
            </AppContext.Provider>
        </Suspense>
    </>
    );
}

export default withAuthContextProvider()(withAITracking(reactPlugin, App));